export default __webpack_public_path__ + "static/media/post-suvinil3.148ff962.png";